<form (ngSubmit)="triggerSearch()">
    <input class="search-input"
           name="search-input"
           [(ngModel)]="searchText"
           type="text"
           pInputText
           placeholder="Ce cauți?">
    <!--<button class="orange-button ml-2" type="submit">Caută</button>-->
</form>
